import { connect } from 'react-redux';

import Elections from './component';

import {
  setSelectedElection,
  updateUser,
  setQueriedAddress,
  setUserSeenAddressPrompt,
} from '../../state/actions';

import { getAuthTokenFromStorage, getUserIdFromStorage } from '../../utils';

const mapStateToProps = (state) => {
  const {
    elections: {
      all_elections: elections,
      elections: queriedElections,
    },
    user: {
      user,
      queried_address: queriedAddress,
      seen_address_prompt: userSeenAddressPrompt,
    },
  } = state;

  const userSavedElections = user.saved_elections || [];
  const userElectionsByAddress = (user.user_elections || []).map(e => e._id);

  return {
    elections,
    isLoggedIn: Object.keys(user).length > 0 && getUserIdFromStorage() && getAuthTokenFromStorage(),
    queriedAddress,
    queriedElections,
    user,
    userElectionsByAddress,
    userSavedElections,
    userSeenAddressPrompt,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSelectedElection: (id) => {
      dispatch(setSelectedElection(id));
    },
    setUserAddress: (address) => {
      dispatch(updateUser({ street_address: address }));
      dispatch(setQueriedAddress(''));
    },
    setUserSeenAddressPrompt: (value) => {
      dispatch(setUserSeenAddressPrompt(value));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Elections);
